import * as administrator from "./administrator";
import * as superAgent from "./superAgent";
import * as company from "./company";
import * as common from "./common";

const post = {
  administrator,
  superAgent,
  company,
  common,
};

export default post;
